import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './coupon.css';
function Coupon({ datas, copyButtonLabel, voucherCodeLabel, noWinMessage, revealBackground }) {
	const [showCode, setShowCode] = useState(false);
	const hasReward = Boolean(datas) && Number(datas.id) !== 44;
	useEffect(() => {
		setShowCode(false);
		if (!hasReward) return;
		const timer = setTimeout(() => setShowCode(true), 1500);
		return () => clearTimeout(timer);
	}, [datas, hasReward]);

	const textCopy = async (txt) => {
		if (!txt) return;
		try {
			let copied = false;
			if (navigator.clipboard?.writeText) {
				try {
					await navigator.clipboard.writeText(txt);
					copied = true;
				} catch (_) { /* Use the webview fallback below. */ }
			}
			if (!copied) {
				const dummy = document.createElement('textarea');
				dummy.value = txt;
				dummy.style.position = 'fixed';
				dummy.style.opacity = '0';
				document.body.appendChild(dummy);
				try {
					dummy.select();
					copied = document.execCommand('copy');
				} finally { dummy.remove(); }
			}
			if (!copied) throw new Error('Clipboard unavailable');
			toast.success('Coupon Code copied to clipboard', { className: 'couponCopyToast', icon: false });
		} catch (_) {
			toast.error('Unable to copy. Please copy the voucher code manually.');
		}
	};
	// Code-mode artwork can contain baked-in voucher text and buttons. Keep the
	// live voucher details as the single source of truth in that state.
	const background = showCode ? undefined : revealBackground;

	return (
		<>
			<div className={`couponRewardCard ${showCode ? 'couponRewardCard--Code' : 'couponRewardCard--Reveal'}`}
				>
				{hasReward ?
					<>
						{<img src={datas.logo || datas.image} alt="Winning brand" className="couponBrandLogo"/>}
						{showCode ? <p>{[datas.winningText, datas.spinText].filter(Boolean).join(' ')}</p> :
							<p>{datas.winningText}<strong className="couponRewardAmount">{datas.spinText}</strong></p>}
						{showCode && <div className="rewardCopyFlex">
							<h4><span>{voucherCodeLabel || 'Your voucher code'}</span>{datas?.code}</h4>
							<button disabled={!datas.code} onClick={() => textCopy(datas.code)}>{copyButtonLabel || 'Copy Code'}</button>
						</div>}
					</>	:
					<div className="nextTimeText">{noWinMessage || 'Better Luck Next Time'}</div>
				}
			</div>
				<ToastContainer
					position="bottom-center"
					autoClose={2000}
					hideProgressBar
					newestOnTop={false}
					// closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
					theme="colored"
				/>
		</>

	);
}

export default Coupon;
